<div class="input">
    <input
        #input
        [value]="value"
        (keyup)="onChange.emit(input.value)"
        (keyup.enter)="onEnterPressed(input)"
        [placeholder]="placeholder"
        [disabled]="disabled"
        type="text"
        class="text-input"
        autocapitalize="none"
        [ngClass]="{ 'text-search': type === 'search' }"
        [attr.data-e2e-hook]="e2eHook"
        [attr.maxlength]="maxLength"
    />
    <span *ngIf="type === 'search'" class="magnifier-icon-container">
        <span class="magnifier-icon"></span>
    </span>
</div>
